import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';

import { Select, SelectChangeEvent } from 'primeng/select';
import { Button } from 'primeng/button';
import { Subject, takeUntil } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Theme, ThemeService } from '../../core/theme/theme.service';
import { PrimeTemplate } from 'primeng/api';

export interface ThemeOption {
  label: string;
  value: Theme;
  icon: string;
}

@Component({
  selector: 'lib-theme-selector',
  imports: [Select, Button, FormsModule, TranslatePipe, PrimeTemplate],
  templateUrl: './theme.component.html',
  styleUrl: './theme.component.css',
})
export class ThemeSelectorComponent implements OnInit, OnDestroy {
  @Input() variant: 'select' | 'toggle' = 'select';
  @Input() size: 'small' | 'large' | undefined = undefined;
  @Input() showLabel = false;
  @Input() placeholder = 'Seleccionar tema';
  @Input() containerClass = '';
  @Input() dropdownClass = '';
  @Input() buttonClass = '';
  selectedTheme: Theme = 'light';
  themeOptions: ThemeOption[] = [
    {
      label: 'common.theme.light',
      value: 'light',
      icon: 'pi pi-sun',
    },
    {
      label: 'common.theme.dark',
      value: 'dark',
      icon: 'pi pi-moon',
    },
  ];
  private themeManagerService = inject(ThemeService);
  private translate = inject(TranslateService);
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.initializeThemeOptions();

    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.initializeThemeOptions();
    });
    this.themeManagerService.theme$.pipe(takeUntil(this.destroy$)).subscribe((theme) => {
      this.selectedTheme = theme;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onThemeChange(event: SelectChangeEvent): void {
    const selectedTheme = event.value as Theme;
    this.themeManagerService.setTheme(selectedTheme);
  }

  toggleTheme(): void {
    this.themeManagerService.toggleTheme();
  }

  getCurrentIcon(): string {
    return this.selectedTheme === 'light' ? 'pi pi-sun' : 'pi pi-moon';
  }

  getCurrentLabel(): string {
    return this.selectedTheme === 'light'
      ? this.translate.instant('common.theme.light')
      : this.translate.instant('common.theme.dark');
  }

  private initializeThemeOptions(): void {
    this.themeOptions = [
      {
        label: this.translate.instant('common.theme.light'),
        value: 'light',
        icon: 'pi pi-sun',
      },
      {
        label: this.translate.instant('common.theme.dark'),
        value: 'dark',
        icon: 'pi pi-moon',
      },
    ];
  }
}
